import { IKeyboardEvent } from "source/app/services/UI/KeyboardEvents/IKeyboardEvents";
import { HandleKeyboardEvent } from "source/app/services/UI/KeyboardEvents/WithKeyboardHotkeys";

export const AttachKeyboardEvents = async (
    keyboardEvents: IKeyboardEvent[]
) => {
    window.addEventListener("keydown", (event) =>
        HandleKeyboardEvent(keyboardEvents, event)
    );
};
